import React from 'react';
import Lottie from 'lottie-react';
import type { LottieComponentProps } from 'lottie-react';

const LightAnimationData = {
  v: '4.8.0',
  nm: 'Logo_Web_Loeader',
  meta: { a: '', k: '', d: '', g: 'LottieFiles AE 2.0.4', tc: '#ffffff' },
  w: 1920,
  h: 1080,
  ip: 0,
  fr: 29.9700012207031,
  op: 30.0000012219251,
  ddd: 0,
  assets: [],
  layers: [
    {
      ty: 4,
      nm: 'Shape Layer 12',
      mn: '',
      sr: 1,
      st: 118.000004806239,
      op: 31.0000012626559,
      ip: 0,
      hd: false,
      cl: '',
      ln: '',
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [216.821, 216.821, 100], ix: 6 },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [1809, 540, 0], ix: 2 },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: 'gr',
          bm: 0,
          cl: '',
          ln: '',
          hd: false,
          mn: 'ADBE Vector Group',
          nm: 'Shape 1',
          ix: 1,
          cix: 2,
          np: 3,
          it: [
            {
              ty: 'sh',
              bm: 0,
              cl: '',
              ln: '',
              hd: false,
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-163.175, -198],
                    [-408, -139],
                    [-410, 105],
                    [-263.912, 166],
                    [-20.123, 106],
                    [-21.368, -140],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: 'st',
              bm: 0,
              cl: '',
              ln: '',
              hd: false,
              mn: 'ADBE Vector Graphic - Stroke',
              nm: 'Stroke 1',
              lc: 1,
              lj: 1,
              ml: 4,
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 24, ix: 5 },
              d: [],
              c: { a: 0, k: [0.0784, 0.0784, 0.0784], ix: 3 },
            },
            {
              ty: 'tr',
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [89.06, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [-189.934, 1.777], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
        {
          ty: 'tm',
          bm: 0,
          cl: '',
          ln: '',
          hd: false,
          mn: 'ADBE Vector Filter - Trim',
          nm: 'Trim Paths 1',
          ix: 2,
          e: {
            a: 1,
            k: [
              {
                o: { x: 0.185, y: 0.925 },
                i: { x: 0.667, y: 1 },
                s: [0],
                t: -14,
              },
              {
                o: { x: 0.331, y: 0.096 },
                i: { x: 0.665, y: 0.731 },
                s: [4],
                t: 0,
              },
              {
                o: { x: 0.333, y: 0.772 },
                i: { x: 0.667, y: 0.446 },
                s: [74.742],
                t: 14,
              },
              {
                o: { x: 0.333, y: 0.486 },
                i: { x: 0.667, y: 0.89 },
                s: [80],
                t: 17,
              },
              {
                o: { x: 0.334, y: -4.416 },
                i: { x: 0.671, y: 3.042 },
                s: [100],
                t: 27,
              },
              {
                o: { x: 0.351, y: -0.02 },
                i: { x: 0.688, y: 1 },
                s: [99],
                t: 47,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.667, y: 1 },
                s: [60],
                t: 54,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.667, y: 1 },
                s: [80],
                t: 73,
              },
              { o: { x: 0.167, y: 0 }, i: { x: 0.667, y: 1 }, s: [100], t: 93 },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [100],
                t: 103.000004195276,
              },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          s: {
            a: 1,
            k: [
              {
                o: { x: 0.204, y: 4.971 },
                i: { x: 0.667, y: 1 },
                s: [0],
                t: -14,
              },
              {
                o: { x: 0.334, y: 0.266 },
                i: { x: 0.667, y: 0.568 },
                s: [1],
                t: 0,
              },
              {
                o: { x: 0.333, y: 0.313 },
                i: { x: 0.667, y: 0.847 },
                s: [55.612],
                t: 17,
              },
              {
                o: { x: 0.333, y: -0.688 },
                i: { x: 0.635, y: 1.251 },
                s: [100],
                t: 27,
              },
              {
                o: { x: 0.352, y: -0.042 },
                i: { x: 0.696, y: 1 },
                s: [80.233],
                t: 47,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.667, y: 1 },
                s: [40],
                t: 54,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.667, y: 1 },
                s: [60],
                t: 73,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [80],
                t: 93,
              },
              {
                o: { x: 0.167, y: 0.167 },
                i: { x: 0.833, y: 0.833 },
                s: [100],
                t: 111.000004521123,
              },
            ],
            ix: 1,
          },
          m: 1,
        },
      ],
      ind: 1,
    },
  ],
};

const DarkAnimationData = {
  v: '4.8.0',
  nm: 'Logo_Web_Loeader',
  meta: { a: '', k: '', d: '', g: 'LottieFiles AE 2.0.4', tc: '' },
  w: 1920,
  h: 1080,
  ip: 0,
  fr: 29.9700012207031,
  op: 30.0000012219251,
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Shape Layer 12',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [1809, 540, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [216.821, 216.821, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-163.175, -198],
                    [-408, -139],
                    [-410, 105],
                    [-263.912, 166],
                    [-20.123, 106],
                    [-21.368, -140],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 24, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [-189.934, 1.777], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [89.06, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.204], y: [4.971] },
                t: -14,
                s: [0],
              },
              {
                i: { x: [0.667], y: [0.568] },
                o: { x: [0.334], y: [0.266] },
                t: 0,
                s: [1],
              },
              {
                i: { x: [0.667], y: [0.847] },
                o: { x: [0.333], y: [0.313] },
                t: 17,
                s: [55.612],
              },
              {
                i: { x: [0.635], y: [1.251] },
                o: { x: [0.333], y: [-0.688] },
                t: 27,
                s: [100],
              },
              {
                i: { x: [0.696], y: [1] },
                o: { x: [0.352], y: [-0.042] },
                t: 47,
                s: [80.233],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                t: 54,
                s: [40],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                t: 73,
                s: [60],
              },
              {
                i: { x: [0.833], y: [0.833] },
                o: { x: [0.167], y: [0.167] },
                t: 93,
                s: [80],
              },
              { t: 111.000004521123, s: [100] },
            ],
            ix: 1,
          },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.185], y: [0.925] },
                t: -14,
                s: [0],
              },
              {
                i: { x: [0.665], y: [0.731] },
                o: { x: [0.331], y: [0.096] },
                t: 0,
                s: [4],
              },
              {
                i: { x: [0.667], y: [0.446] },
                o: { x: [0.333], y: [0.772] },
                t: 14,
                s: [74.742],
              },
              {
                i: { x: [0.667], y: [0.89] },
                o: { x: [0.333], y: [0.486] },
                t: 17,
                s: [80],
              },
              {
                i: { x: [0.671], y: [3.042] },
                o: { x: [0.334], y: [-4.416] },
                t: 27,
                s: [100],
              },
              {
                i: { x: [0.688], y: [1] },
                o: { x: [0.351], y: [-0.02] },
                t: 47,
                s: [99],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                t: 54,
                s: [60],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0.167] },
                t: 73,
                s: [80],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.167], y: [0] },
                t: 93,
                s: [100],
              },
              { t: 103.000004195276, s: [100] },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 0,
      op: 31.0000012626559,
      st: 118.000004806239,
      bm: 0,
    },
  ],
};

type Props = LottieComponentProps & {
  width?: string | number;
  height?: string | number;
  variant?: 'light' | 'dark';
};

const LoadingSpinner: React.FC<Props> = ({
  width = 150,
  height = 84,
  variant = 'light',
  ...props
}) => {
  return (
    <Lottie
      animationData={variant == 'dark' ? DarkAnimationData : LightAnimationData}
      loop={true}
      style={{ ...props.style, width, height }}
      {...props}
    />
  );
};

export default LoadingSpinner;
